import React from "react";

// css
import "./style.css";

export interface VCLabelProps {
  label: React.ReactNode | string;
  className?: string;
}

const index = (props: VCLabelProps) => {
  const { label, className } = props;

  return <label className={className}>{label}</label>;
};

export default index;
